<header class="mast-main-head fixed-top">

  <!-- <div class="main-header-subscriber-offer-section">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/home"><img src="assets/img/logo.svg"></a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/how-it-works" style="cursor: pointer;">How it works</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" (click)="openMarketplace()" style="cursor: pointer;">Marketplace</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/pricing">Pricing</a>
          </li>
          <li class="nav-item dropdown col-1-dropdown">
            <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
            <div class="dropdown-menu" style="width: 200px;">
              <ul>
                <li><a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                  <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                  <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Icons/Navigation/Arrow Down/Black">
                      <g id="Group">
                        <path id="down_arrow" d="M18.5 9.44444L12.3274 15L6 9.57345" stroke="#b2b2b2" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                    </g>
                  </svg> -->
                </li>
                <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                  <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
                <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                  <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
          </li>
           <li class="nav-item signup-btn">
          <a class="nav-link button" href="profile.html" data-toggle="modal" routerLink="/login">Start for free</a>
          </li>
          <li class="nav-item login-btn">
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<section class="community-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h1>Join a community designed to help you grow as a <b class="freelaner-txt">Fr</b> designer</h1>
        <p>Meet, share, learn and grow with over 60k+ amazing creative people from all around the globe.</p>
        <div class="btn-wrapper">
          <a class="button enterprise-buy-now">Join the community</a>
          <a class="button light-blue-btn">Learn more</a>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="about-steps">
	<div class="container">
		<div class="row">
			<div class="col-md-12 text-center about-steps-main-title">
				<h2 class="" style="background-image: url(assets/img/about-rocket.png);">Steps Toward Future</h2>
			</div>
			<div class="col-md-4">
				<div class="about-steps-box">
					<h3><span>01</span></h3>
					<h3 class="about-steps-title">Creative talent</h3>
					<p>Connect with a community of hundreds of top-rated designers and creative people and collaborate as team and grow together.</p>
				</div>
			</div>
			<div class="col-md-4">
				<div class="about-steps-box">
					<h3><span>02</span> </h3>
					<h3 class="about-steps-title">Unlimited projects</h3>
					<p>Unleash your potential with endless possibilities where projects know no limit. We assure you, we won't let you bored.</p>
				</div>
			</div>
			<div class="col-md-4">
				<div class="about-steps-box">
					<h3><span>03</span> </h3>
					<h3 class="about-steps-title">Ofcourse learning</h3>
					<p>Discover, learn and enjoy the journey to expertise and empower your minds beyond limits with us.</p>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="designed-area">
  <div class="container">
    <div class="row">
      <div class="col-md-1">
      </div>
      <div class="col-md-3">
        <div class="common-box text-center">
          <svg width="60px" height="60px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Icons/People" stroke="black" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Group-9" transform="translate(4.000000, 5.000000)" stroke="black">
                      <path d="M9.0372,3.70386667 C9.0372,5.5652 7.52786667,7.07453333 5.66653333,7.07453333 C3.8052,7.07453333 2.29586667,5.5652 2.29586667,3.70386667 C2.29586667,1.84253333 3.8052,0.3332 5.66653333,0.3332 C7.52786667,0.3332 9.0372,1.84253333 9.0372,3.70386667 Z" id="Stroke-1"></path>
                      <path d="M10.3333333,14.3705333 L1,14.3705333 C0.632,14.3705333 0.333333333,14.0718667 0.333333333,13.7038667 L0.333333333,12.4978667 C0.333333333,10.2885333 2.124,8.49786667 4.33333333,8.49786667 L7,8.49786667 C9.20933333,8.49786667 11,10.2885333 11,12.4978667 L11,13.7038667 C11,14.0718667 10.7013333,14.3705333 10.3333333,14.3705333 Z" id="Stroke-3"></path>
                      <path d="M10.3802,0.333333333 C12.2415333,0.333333333 13.7508667,1.84266667 13.7508667,3.704 C13.7508667,5.56533333 12.2415333,7.07466667 10.3802,7.07466667" id="Stroke-5" stroke-linecap="round"></path>
                      <path d="M11.0468667,8.49773333 L11.7135333,8.49773333 C13.9228667,8.49773333 15.7135333,10.2884 15.7135333,12.4977333 L15.7135333,13.7037333 C15.7135333,14.0724 15.4148667,14.3704 15.0468667,14.3704 L12.6548667,14.3704" id="Stroke-7" stroke-linecap="round"></path>
                  </g>
              </g>
          </svg>
          <h1 class="">50K+</h1>
          <p>Designers</p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="common-box text-center">
          <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 7V17M20 7V17" stroke="black" stroke-width="1.5" stroke-linejoin="round"/>
          <path d="M20 17C20 18.6569 16.4183 20 12 20C7.58172 20 4 18.6569 4 17" stroke="black" stroke-width="1.5"/>
          <path d="M20 12C20 13.6569 16.4183 15 12 15C7.58172 15 4 13.6569 4 12" stroke="black" stroke-width="1.5"/>
          <ellipse cx="12" cy="7" rx="8" ry="3" stroke="black" stroke-width="1.5"/>
          </svg>
          <h1 class="">4TB</h1>
          <p>Storage</p>
        </div>
      </div>
      <div class="col-md-3">
        <div class="common-box text-center">
            <svg width="60" height="60" viewBox="0 0 220 192" class="" fill="black" aria-hidden="true" focusable="false"><rect width="256" height="256" fill="none"></rect><path d="M200,40 L130.66667,40 C127.204747,40 123.836209,38.8771541 121.066671,36.8000006 L93.33333,16 L48,16 L48,40 C48,44.418278 44.418278,48 40,48 C35.581722,48 32,44.418278 32,40 L32,16 C32,7.163444 39.163444,0 48,0 L93.33333,0 C96.7952534,0 100.163791,1.12284595 102.933329,3.19999945 L130.66667,24 L200,24 C208.836556,24 216,31.163444 216,40 L216,128.88889 C216,132.896606 214.407941,136.740176 211.574058,139.574058 C208.740176,142.407941 204.896606,144 200.88889,144 L176,144 C171.581722,144 168,140.418278 168,136 C168,131.581722 171.581722,128 176,128 L200,128 L200,40 Z" id="Shape"></path><path d="M168,72 L98.66667,72 C95.2047466,72 91.8362087,70.8771541 89.0666707,68.8000006 L61.33333,48 L16,48 L16,160 L168,160 L168,72 Z M184,72 L184,160.88889 C184,169.234526 177.234526,176 168.88889,176 L16,176 C7.163444,176 0,168.836556 0,160 L0,48 C0,39.163444 7.163444,32 16,32 L61.33333,32 C64.7952534,32 68.1637913,33.1228459 70.9333293,35.1999994 L98.66667,56 L168,56 C176.836556,56 184,63.163444 184,72 Z" id="Shape"></path></svg>
          <h1 class="">Board</h1>
          <p>Unlimited</p>
        </div>
      </div>
      <div class="col-md-1">
      </div>
    </div>
  </div>
</section>

<section class="field-section-new">
  <div class="container">
  	<div class="row">
  		<div class="col-sm-12">
  			<h2>Make yourself more productive <span>with Crafttor</span></h2>
  			<div class="inner-content">
  				<form class="form-horizontal" [formGroup]="newUserRegisterForm" (submit)="getUserProfile()">
  					<div class="form-group">
  						<div class="col-md-12">
  						<label class="control-label" for="name">Name</label>
  						<input formControlName="fullName" id="fullName" name="textinput" type="text" placeholder="Your full name" class="form-control input-md" required="">
  						</div>
  					</div>

  					<!-- Text input-->
  					<div class="form-group">
  						<div class="col-md-12">
  						<label class="control-label" for="email">Username</label>
  						<input formControlName="userName" id="fullEmail" name="textinput" type="email" placeholder="Username" class="form-control input-md" required="">
  						</div>
  					</div>

            <!-- Text input-->
  					<div class="form-group">
  						<div class="col-md-12">
  						<label class="control-label" for="email">Email</label>
  						<input formControlName="fullEmail" id="fullEmail" name="textinput" type="email" placeholder="name@email.com" class="form-control input-md" required="">
  						</div>
  					</div>

            <!-- Text input-->
  					<div class="form-group">
  						<div class="col-md-12">
  						<label class="control-label" for="email">Password</label>
  						<input formControlName="password" id="fullEmail" name="textinput" type="email" placeholder="**********" class="form-control input-md" required="">
  						</div>
  					</div>

            <!-- Select -->
  					<div class="form-group">
  						<div class="col-md-12">
  						<label class="control-label" for="your-profile">Your profile</label>
  						<select (change)="selectUserProfile($event)" class="input-md" id="profile">
  							<option value="Freelancer">Freelancer</option>
                <option value="Employee">Employee</option>
  							<option value="Business">Business</option>
  						</select>
  						</div>
  					</div>

  					<!-- Button -->
  					<div class="form-group">
  						<div class="col-md-12">
  						<button id="singlebutton" name="singlebutton button" class="btn btn-primary">Register</button>
  						<span class="terms">By submitting the form, you agree with our <a routerLink="/terms" target="_blank">Terms & Conditions</a>, and <a routerLink="/terms" target="_blank">Privacy</a>.</span>
  						</div>
  					</div>
  				</form>
  			</div>
  		</div>
  	</div>
  </div>
</section>

<section class="community-bottom-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h1>A new way to learn and design</h1>
        <div class="btn-wrapper">
          <a class="button">Connect with us</a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="site-footer">
  <div class="container">
    <div class="row">
      <div class="col-sm-3">
        <div class="coulmn-1">
  				<img src="assets/img/logo.svg">
  				<p>Digital assets management</p>
  				<a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
  			</div>
      </div>
      <!-- 3 -->
      <div class="col-sm-2">
        <h5>Products</h5>
        <ul class="menu">
          <li><a routerLink="/home">Workspace</a></li>
          <li><a (click)="openMarketplace()">Marketplace</a></li>
          <li><a routerLink="/features">Features</a></li>
          <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
<li><a routerLink="/smart-storage">Smart storage</a></li>
          <li><a routerLink="/effective-search">Effective search</a></li>

        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Plugins</h5>
        <ul class="menu">
          <li><a href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
          <li><a href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
          <li><a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
          <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
          <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
          <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
          <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
<li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Solutions</h5>
        <ul class="menu">
          <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
          <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
          <li><a routerLink="/box-alternative">Box alternative</a></li>
          <li><a routerLink="/content-library">Content library</a></li>
          <li><a routerLink="/user-profiling">User Profiling</a></li>
<li><a routerLink="/approvals">Creative approvals</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Features</h5>
        <ul class="menu">
          <li><a routerLink="/features/tagging">Tagging</a></li>
          <li><a routerLink="/features/sharing">Sharing</a></li>
          <li><a routerLink="/features/versioning">Versioning</a></li>
          <li><a routerLink="/features/collaboration">Collaboration</a></li>
          <li><a routerLink="/features/integration">Integration</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Company</h5>
        <ul class="menu">
          <li><a routerLink="/about-workspace">About Workspace</a></li>
          <li><a routerLink="/contact">Contact Us</a></li>
          <li><a routerLink="/terms">Terms & Conditions</a></li>
          <li><a routerLink="/faq">FAQ</a></li>
          <li><a routerLink="/feedbacks">Feedback</a></li>
          <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
          <li><a routerLink="/our-mission">Our mission</a></li>
          <li><a routerLink="/partner-with-us">Partner with us</a></li>
        </ul>
      </div>

      <div class="col-sm-3 all-social-icons">
        <h5>Socials</h5>
        <ul class="social-icons">
          <li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
            alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
        </ul>
      </div>

      <div class="col-sm-12 text-center">
  			<small>&copy; 2025 Crafttor. All rights reserved</small>
  		</div>
    </div>
  </div>
</footer>
